module.exports = {
    Copyright:'Copyright © 2023  by game empire',
    CopySucceeded:'Copy succeeded',
    play:'ကစားမယ်',
    viewAll:'အားလုံးကိုကြည့်မည်',
    myAccount:'ကျွန်ုပ်၏အကောင့်',
    MyGames:'ကျွန်ုပ်၏ဂိမ်းများ',
    password:'လျှို့ဝှက်နံပတ်',
    ChangePassword:'လျှို့ဝှက်နံပတ်ပြောင်းမည်',
    OldPassword:'လျှို့ဝှက်နံပတ်အဟောင်း',
    newPassword:'လျှို့ဝှက်နံပတ်အသစ်',
    FAQs:'မေးလေ့မေးထရှိသောမေးခွန်းများ',
    TC:'စည်းမျဥ်းစည်းကမ်းများ',
    language:'ဘာသာစကား',
    Submit:'အတည်ပြုမည်',
    submit2:'ထည့်သွင်းပါ',
    change:'ပြောင်းမည်',
    English:'အင်္ဂလိပ်',
    showMore:'နောက်ထပ်ကြည့်ရှုရန်',
    Login:'ဝင်မည်',
    Logout:'ထွက်မည်',
    getCode:'OTP ပို့ပါ',
    phoneNumber:'ဖုန်းနံပါတ်',
    drawPrize:'ရင်ခုန်ဖွယ်ရာ ဆုလက်ဆောင်များ',
    drawfont:'သုံးလပြည့်တိုင်း ကံထူးနိုင်ပြီ',
    Name:'အမည်',
    phone:'ဖုန်း',
    Prize:'ဆု',
    missions1:"ဒါတွေက သင်ရဲ့ မစ်ရှင်တွေပါ။<br />မစ်ရှင်တွေကို ပြီးမြောက်အောင် လုပ်ဆောင်ပြီး<br /> ပွိုင့်တွေ ရယူလိုက်ပါ",
    missions2:'သင်၏မစ်ရှင်များ',
    Save:'သိမ်းမည်',
    YourRecords:'သင်၏မှတ်တမ်းများ',
    menmberSince:'အဖွဲ့ဝင်စဖြစ်သည့်အချိန်',
    lastLogin:'နောက်ဆုံးအကြိမ်ဝင်ရောက်မှု',
    gamesYouPlay:'ကစားခဲ့သည့်ဂိမ်းများ',
    playAce:'ကစားသမား ACE <br />(ယခုလ)',
    cancel:'ပယ်ဖျက်မည်',
    Confirm:'အတည်ပြုမည်',
    No:'မလုပ်ဆောင်ပါ',
    OK:'အိုကေ',
    Yes:'လုပ်ဆောင်မည်',
    Okay:'အိုကေ',
    UNSUBSCRIBE:'ဝန်ဆောင်မှုမှ ပယ်ဖျက်မည်',
    noMore:'ပိုမိုကြည့်ရှုရန်',
    more:'ပို၍ကြည့်ရှုရန်',
    des2:'သင်​၏လက်ရှိအမှတ်များ သုညသို့ရောက်ရှိသွားပါမည်။ ဝန်ဆောင်မှုမှ ပယ်ဖျက်ရန် သေချာပြီလား',
    myPoints:'ကျွန်ုပ်၏ရမှတ်များ',
    myPointsTips1:'အမှတ်များကို ၆လအတွင်း ဆုလက်ဆောင်များဖြင့် လဲလှယ်ရယူနိုင်မည်ဖြစ်ပြီး ဝန်ဆောင်မှုကို စာရင်းသွင်းခြင်းမှ ပယ်ဖျက်လိုက်သည်နှင့် တစ်ပြိုင်နက် ရမှတ်အားလုံးအသစ်မှ ပြန်လည်စတင်မည် ဖြစ်ပါသည်။',
    pointHistory:'ရမှတ်မှတ်တမ်းများ',
    time:'အချိန်',
    description:'ဖော်ပြချက်',
    points:'ရမှတ်များ',
    redeemCenter:'ရမှတ်လဲလှယ်ရန်',
    redeemTips1:'ဂိမ်းကစားခြင်းဖြင့် အမှတ်များစုဆောင်းပြီး ဆုများကို လဲလှယ်လိုက်ပါ!',
    redeemTips2:'အမှတ်များကို ၆လအတွင်း ဆုလက်ဆောင်များဖြင့် လဲလှယ်ရယူနိုင်မည်ဖြစ်ပြီး ဝန်ဆောင်မှုကို စာရင်းသွင်းခြင်းမှ ပယ်ဖျက်လိုက်သည်နှင့် တစ်ပြိုင်နက် ရမှတ်အားလုံး သုညသို့ ရောက်ရှိသွားမည်ဖြစ်ပါသည်။',
    redeemTips3:'ကျေးဇူးပြု၍ အတည်ပြုပါ။ သင့်အကောင့်အတွင်းရှိအမှတ်များကို သင်လဲလှယ်လိုသောဆုများဖြင့် လဲလှယ်ပေးပါမည်။ သင်အတည်ပြုပြီးနောက် ဤလုပ်ဆောင်ချက်ကို ပြန်ပြင်၍မရပါ',
    redeemTips4:'လဲလှယ်လိုသောဆုမှာ MPT TOP UP 12,000ks ဖြစ်ပါသည်။ သင့်အကောင့်ရှိ အမှတ် 6000 ကို လဲလှယ်ပါမည်။ သင် ဆက်လက်လုပ်ဆောင်လိုပါသလား',
    // redeemTips41 , redeemTips5 是 redeemTips4的分解
    redeemTips41:'သင်လဲလှယ်လိုသောဆုမှာ MPT ဖြစ်သည် ',
    redeemTips5:'သင့်အကောင့်ရှိ အမှတ်များကို လဲလှယ်ပါမည်။ သင် ဆက်လက်လုပ်ဆောင်လိုပါသလား',
    redeemTips6:'ဂုဏ်ယူပါတယ်',
    redeemTips7:'ဝမ်းနည်းပါတယ်',

    referralTips1:"သူငယ်ချင်းကို ဂိမ်းအင်ပါယာအကြောင်း<br /> ညွှန်းပြီး ၁၀ ပွိုင့် ရယူလိုက်ကြရအောင်။<br />အချိန်တိုင်း ပျော်ရွှင်ဖို့ တူတူ ကစားကြစို့",
    memberGetMember:'သူငယ်ချင်းကိုရည်ညွှန်းမယ်',
    referralTips2:'ဒါကသင့်ရဲ့ ရည်ညွှန်းအိုင်ဒီပါ',
    referralTips3:'ဒါကသင့်သူငယ်ချင်းရဲ့ ရည်ညွှန်းအိုင်ဒီပါ',
    playNow:'ယခုကစားမည်',
    headerTips1:"ဂိမ်းတွေ ကစားပြီး ပွိုင့်တွေ ရယူလိုက်ကြရအောင်။ ဂိမ်းတွေ ကစားပြီး ဆုလက်ဆောင်များကို အခုပဲ ရယူလိုက်ပါ",
    headerTips2:'သင်သည် သင့်အကောင့်ထဲသို့ ဝင်ရောက်ထားပြီး ဖြစ်ပါသည်',
    FeaturedGames:'ထူးခြားထင်ရှားအထင်ကရဂိမ်းများ',
    Populargames:'လူကြိုက်များသောဂိမ်းများ',
    Allgames:'ဂိမ်းအားလုံး',
    cgtips1:'<span class="fs46">ဂိမ်းအင်ပါယာထဲက အကောင်းဆုံးဂိမ်းတွေကို ဝင်ရောက်ဆော့ကစားလိုက်ပါ။</span>',
    cgtips2:'စာရင်းသွင်းခြင်းမှ ဖြုတ်သိမ်းရန်အတွက် 65139 သို့ OFF ဟုပေးပို့၍ အချိန်မရွေး စာရင်းသွင်းခြင်းမှ ဖြုတ်သိမ်းနိုင်ပါသည်။',
    cgtips3:'ကျွန်ုပ် ဖတ်ရှုပြီး လက်ခံပါသည်',
    cgtips4:' ဆားဗစ်အတွက် ကျွန်ုပ်၏ မိုဘိုင်းအကောင့်ထဲမှ ကျသင့်ငွေ ကောက်ခံမည်ကို ကျွန်ုပ်လက်ခံသဘောတူညီပါသည်',
    Scores:'ရမှတ်များ',
    Status:'အခြေအနေ',
    noFound:'မည်သည့်ရလဒ်ကိုမျှ မတွေ့ပါ!',
    TCtitile:"<strong>ဝန်ဆောင်မှုဆိုင်ရာအဖိုးအခကောက်ခံခြင်းဆိုင်ရာစည်းကမ်းချက်များ</strong><br />",
    hang1:"<span>•၁။စာရင်းပေးသုံးစွဲ မှုရယူထားသော ဝန်ဆောင်မှု၏တရားဝင်အသုံးပြုနိုင်သည့်ကာလမှာ ၃၆၅ ရက်ဖြစ်ပြီး နေ့စဉ်/ အပတ်စဉ်/လစဉ်အရစ်ကျငွေပေးချေမှုစနစ်ဖြင့် ရွေးချယ်ထားသောဝန်ဆောင်မှုပေါ်မူတည်ပြီး အသုံးပြုနိုင်မှာဖြစ်ပါတယ်။ </span>",
    hang2:"<span>၂။အသုံးပြုမှုအတွက်အဖိုးအခကို ကောက်ခံသည့်အကြိမ်ရေမှာ တစ်ကြိမ် (ဥပမာသက်တမ်းတိုးမှုမပါသော သို့မဟုတ် နေ့စဉ်ကောက်ခံမှုမရှိသော) သို့မဟုတ် အစဉ်အဆက်လိုက် (ဥပမာ-အပတ်အလိုက်/ လအလိုက်ကောက်ခံမှုရှိသည့်၃၆၅ရက် အသုံးပြုနိုင်သည့်ဝန်ဆောင်မှု) ဖြစ်နိုင်ပါသည်။ </span>",
    hang3:'<span>•၃။အကယ်၍ အက်တမ်၏ မိတ်ဖက်ကုမ္မဏီများမှ ဝန်ဆောင်မှုတွင်အခမဲ့ စမ်းသပ်အသုံးပြုကာလပါရှိပါက အသုံးပြုသူသည်သတ်မှတ်ထားသည့် အခမဲ့စမ်းသပ်အသုံးပြုကာလ အတွက်သာဝန်ဆောင်မှုကိုအခမဲ့ အသုံးပြုနိုင်မည်ဖြစ်သည်။ ထိုအခမဲ့စမ်းသပ်ကာလပြီးဆုံးပါက သင်၏ မိုဘိုင်းလက်ကျန်ငွေထဲမှဝန်ဆောင်မှုအတွက် နေ့စဉ်/ အပတ်စဉ်/ လစဉ်ကျသင့်ငွေကို ကောက်ခံမည်ဖြစ်သည်။ </span>',
    hang4:'<span>•၄။သုံးစွဲသူဘက်မှ ရယူထားသည့်ဝန်ဆောင်မှုအသုံးပြုနေခြင်းကို ပယ်ဖျက်နိုင်ပါတယ်။ ထိုသို့စာရင်းပယ်ဖျက်ရန် အကြောင်းကြားမှုလက်ခံရရှိပြီးနောက် ကျွန်ုပ်တို့ အက်တမ်အနေဖြင့် ဝန်ဆောင်မှုအသုံးပြုခကို ကောက်ခံတော့မည်မဟုတ်ပါ။ </span>',
    hang5:'<span>•၅။ဝန်ဆောင်မှုကိုရယူသည်ဟု အတည်ပြုမှုသည် ဤဝန်ဆောင်မှုဆိုင်ရာ အဖိုးအခကောက်ခံခြင်း ဆိုင်ရာစည်းကမ်းချက်များကို ကိုယ်တိုင်အသိအမှတ်ပြု လက်ခံကြောင်းအတည်ပြုပါသည်။ ဝန်ဆောင်မှုကိုလက်ခံပြီးသည်နှင့်တစ်ပြိုင်နက်စည်းမျဉ်းစည်းကမ်းချက်များကိုလက်ခံပြီး ဖြစ်ပါသည်။</span>',
 cardMissions1:'လုပ်ကြရအောင်',
  cardMissions2:'ချုပ်ဆောင်ချက်များ',
  cardMissions3:"Game Empire မှာ ဂိမ်းတွေ ဆော့ပြီး<br /> ဆုလက်ဆောင်တွေ ရယူလိုက်ကြရအောင်<br />အခုပဲ ဆော့လိုက်ပါ !!!",
  Subscribe:"စာရင်းသွင်းပါ။",
  Register:'ဝန်ဆောင်မှုရယူမည်',
  subTips:'တစ်ရက်လျှင် ၉၉ကျပ်သာ',
  referral_tip:'သင့် ရည်ညွှန်းအိုင်ဒီကို SMS သို့ Viber, Messenger မှတဆင့် သူငယ်ချင်းထံသို့မျှဝေပါ။',
  Insufficient_Balance: 'ဝန်ဆောင်မှု ရယူခြင်း မအောင်မြင်ပါ။ လက်ကျန်ငွေ မလုံလောက်ပါ။',
  Subscription_failed: 'မှတ်ပုံတင်ခြင်း ကျဆုံးပါသည်။ ',
  GrandPrize:'အထူးဆုကြီးများ',
  FirstPrize:'ပထမဆု',
  SecondPrize:'ဒုတိယဆု',
  tips:'သင့်ဖုန်းနံပါတ်ကို ထည့်ပါ။',

}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js